import { render } from "./scenario-approved.vue?vue&type=template&id=744e4685&ts=true"
import script from "./scenario-approved.vue?vue&type=script&lang=ts"
export * from "./scenario-approved.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__